import { useEffect, useState } from 'react'

interface AddToCartAnimationProps {
  startElement: HTMLElement
  onComplete?: () => void
}

export default function AddToCartAnimation({
  startElement,
  onComplete,
}: AddToCartAnimationProps) {
  useEffect(() => {
    const startRect = startElement.getBoundingClientRect()

    const endPosition = {
      x: window.innerWidth - 50,
      y: 50,
    }

    // Create the animation dot
    const dot = document.createElement('div')
    dot.style.cssText = `
      position: fixed;
      width: 24px;
      height: 24px;
      background-color: #222;
      border-radius: 50%;
      z-index: 9999;
      pointer-events: none;
      left: ${startRect.left + startRect.width / 2}px;
      top: ${startRect.top + startRect.height / 2}px;
      transition: all 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    `

    document.body.appendChild(dot)

    // Trigger animation
    requestAnimationFrame(() => {
      dot.style.transform = 'scale(0.5)'
      dot.style.left = `${endPosition.x}px`
      dot.style.top = `${endPosition.y}px`
    })

    // Cleanup
    const timer = setTimeout(() => {
      dot.remove()
      onComplete?.()
    }, 600)

    return () => {
      clearTimeout(timer)
      dot.remove()
    }
  }, [startElement, onComplete])

  return null
}
